import { extend } from 'flarum/extend';
import IndexPage from 'flarum/components/IndexPage';

export default function() {
  // Remove "All discussion" links from left sidebar
  extend(IndexPage.prototype, 'navItems', function(items) {
      items.remove('allDiscussions');
  });
}
